import type { ContactId } from '../../../lib/contact-book';
import { ContactsBody } from './ContactsBody';
import { ContactDetailBody } from './ContactDetailBody';

/**
 * The Outreach section under the map home: the SAME contacts list (every line a person, the last
 * communication the order, search, the New / Action required chips, mark-all-read) and, once a contact is
 * picked, the SAME correspondence view the /contacts pages render — inline. The picked contact rides the
 * URL so a refresh keeps the place; a counterparty the book knows only by an address is picked by its
 * recipient id, exactly as on the standalone pages.
 *
 * Body only — it renders NO back control. The one back control lives in the map-home section chrome that
 * wraps this (`MapHome` + `mapSectionBack`), which steps back to this list while a contact is open and to
 * the map otherwise. A back button here was the second of two stacked ones on a contact's detail.
 */
export function OutreachTabBody({ contactId, onOpen }: { contactId: ContactId | null; onOpen: (id: ContactId) => void }) {
  if (contactId) return <ContactDetailBody id={contactId} />;
  return <ContactsBody onOpen={onOpen} />;
}
